import { BuildingOffice2Icon } from "@heroicons/react/24/outline";
import { useAppLocation, useAppNavigate, useAppSearch } from "_graphql/cache/auth";
import { ActionButton, OfficeButton, OfficeHeader, Paginator } from "components";
import Table from "components/tables/table";
import { usePagination } from "hooks";
import { useAutoFacConfigurationParticipants } from "hooks/data/use-aut-fac";
import { FC } from "react";
import CreateAutoFacParticipantsContainer from "./create";
import RemoveContainer from "./remove";
import { Action } from "components/buttons/action-button";
import AddParticipantsPercentageContainer from "./update";
import { GetAutoFacParticipants_getAutoFacParticipants } from "_graphql/queries/__generated__/GetAutoFacParticipants";
import ViewContainer from "./view";

type AutoFacAconfigationsParticipantsPageProps = {};

const AutoFacAconfigationsParticipantsPage: FC<AutoFacAconfigationsParticipantsPageProps> = () => {
    const { params } = useAppLocation()
    const searchParams = useAppSearch()
    const navigate = useAppNavigate();
    const { offset, limit, setPage, setLimit } = usePagination();
    const { length, configs, refetch, loading } = useAutoFacConfigurationParticipants({
        autoFacConfigId: Number(params?.id) || 0,
        limit: limit,
        offset: offset
    })


    const dispatchAction =
        (id: string, action: Exclude<Action, "expand" | "goto" | "clone">) =>
            () => {
                navigate({
                    search: (old) => ({
                        ...old,
                        id,
                        modal: action,
                    }),
                });
            };

    return (
        <main className="flex-1 flex flex-col overflow-hidden bg-background-500">
            <OfficeHeader renderActions={() => (
                <OfficeButton onClick={() => navigate({
                    search(prev) {
                        return {
                            ...prev,
                            modal: "create"
                        }
                    },
                })}>
                    Add Participants
                </OfficeButton>
            )} />
            <div className="flex flex-1 overflow-y-auto">
                <div className="flex-1 mx-auto min-w-0  py-4 sm:py-6 overflow-hidden overflow-y-auto light flex">
                    <Table title={params?.id || ""}
                        loading={loading}
                        hasSearch
                        columns={[
                            {
                                name: "Name",
                                accessor: "name",
                                render: (item: GetAutoFacParticipants_getAutoFacParticipants) => (
                                    <div className="flex items-center space-x-2">
                                        <BuildingOffice2Icon className="h-6 w-6" />
                                        <div className="flex-1 flex flex-col">
                                            <span> {item.reinsurer?.re_company_name}</span>
                                            <span className="font-light text-xs"> {item.reinsurer?.re_company_email}</span>
                                        </div>
                                    </div>
                                )
                            },
                            {
                                name: "Created By",
                                accessor: "employee.employee_first_name",
                                render: (item: GetAutoFacParticipants_getAutoFacParticipants) => (
                                    <div className="flex items-center space-x-2">
                                        <div className="flex-1 flex flex-col">
                                            <span> {item.employee?.employee_first_name} {item.employee?.employee_last_name}</span>
                                        </div>
                                    </div>
                                )
                            },
                            {
                                name: "Participating Percentage",
                                accessor: "created_at",
                                render: (item: GetAutoFacParticipants_getAutoFacParticipants) => (
                                    <div className="flex items-center space-x-2">
                                        <div className="flex-1 flex flex-col">
                                            <span> {item.share_percentage}%</span>
                                        </div>
                                    </div>
                                )
                            },
                            // {
                            //     name: "Updated At",
                            //     accessor: "updated_at",
                            //     render: (item: GetAutoFacConfiguration_getAutoFacConfiguration_auto_fac_participants) => (
                            //         <div className="flex items-center space-x-2">
                            //             <div className="flex-1 flex flex-col">
                            //                 <span> {item.}</span>
                            //             </div>
                            //         </div>
                            //     )
                            // },
                            {
                                name: "Actions",
                                accessor: "created_at",
                                render: (item: GetAutoFacParticipants_getAutoFacParticipants) => (
                                    <>
                                        <ActionButton action="view" onClick={dispatchAction(item?.auto_fac_participant_id?.toString() || "", "view")} />
                                        <ActionButton action="update" onClick={dispatchAction(item?.auto_fac_participant_id?.toString() || "", "update")} />
                                        <ActionButton action="remove" extraClassName="text-red-400" onClick={dispatchAction(item?.auto_fac_participant_id?.toString() || "", "remove")} />
                                    </>
                                )
                            },
                        ]} data={configs} refetch={refetch}
                        pagination={() => <Paginator offset={offset} limit={limit} totalItems={length} currentSize={configs.length} setOffset={setPage} />}

                    />
                </div>
            </div>
            <CreateAutoFacParticipantsContainer open={searchParams?.modal === "create"} setOpen={(value) => {
                navigate({
                    search(prev) {
                        return {
                            ...prev,
                            modal: value ? "create" : undefined
                        }
                    },
                })
            }} />
            {searchParams?.id && searchParams?.modal === "remove" && (
                <RemoveContainer open={searchParams?.modal === "remove"} setOpen={(value) => {
                    navigate({
                        search(prev) {
                            return {
                                ...prev,
                                id: value ? searchParams.id : undefined,
                                modal: value ? "remove" : undefined
                            }
                        },
                    })
                }} />
            )}
            {searchParams?.id && searchParams?.modal === "update" && (
                <AddParticipantsPercentageContainer open={searchParams?.modal === "update"} setOpen={(value) => {
                    navigate({
                        search(prev) {
                            return {
                                ...prev,
                                id: value ? searchParams.id : undefined,
                                modal: value ? "update" : undefined
                            }
                        },
                    })
                }} />
            )}
            {searchParams?.id && searchParams?.modal === "view" && (
                <ViewContainer open={searchParams?.modal === "view"} setOpen={(value) => {
                    navigate({
                        search(prev) {
                            return {
                                ...prev,
                                id: value ? searchParams.id : undefined,
                                modal: value ? "view" : undefined
                            }
                        },
                    })
                }} />
            )}
        </main>
    )
};

export default AutoFacAconfigationsParticipantsPage;
